import * as React from 'react';
import { uniqueId } from 'lodash';
import { AddButton, BodyGroup } from '@component/index';
import { instance, isReadMode } from '@lib/index';
import { FrameMappingTableComp } from './frame-mapping-table';
import '@style/component/data-query.less';
import { localizedString } from '@locale/index';
import {
  Attribute,
  FrameMappingUpdateFuncArgumentConfig,
  FrameMapping,
  FrameItem,
  CompositeInfo
} from '@interface/index';

export interface FrameMappingCompProps {
  title: string;
  frame: FrameItem;
  availableComposites: CompositeInfo[];
  disabled?: boolean;
  data: FrameMapping[];
  selectedParameters: Attribute[];
  onChange: (args: FrameMappingUpdateFuncArgumentConfig) => void;
}
export interface FrameMappingCompState {
  tag: string;
}

export class FrameMappingComp extends React.PureComponent<
  FrameMappingCompProps,
  FrameMappingCompState
> {
  public state: FrameMappingCompState = {
    tag: uniqueId()
  };

  private bodyGroup?: BodyGroup;

  render() {
    const { disabled = false,
      title,
      frame
    } = this.props;

    return (
      <BodyGroup
        title={title.length ? title : localizedString('state_update')}
        foldable={false}
        defaultFolded={false}
        extra={(<AddButton
          disabled={disabled || !!frame.originKey}
          onClick={() => {
            this.handleNewTableRow();
          }}
        />)
        }
        onRef={(ref: any) => {
          this.bodyGroup = ref;
        }}
      >
        <div className="suggestion__wrap">
          <div className="sug-wrap">{this.tableComp()}</div>
        </div>
      </BodyGroup>
    );
  }

  tableComp = () => {
    const props = this.props;
    const state = this.state;
    const {
      availableComposites
    } = props;

    return (
      <FrameMappingTableComp
        title={props.title}
        frame={props.frame}
        availableComposites={availableComposites}
        tag={state.tag}
        disabled={props.disabled}
        selectedParameters={props.selectedParameters}
        data={props.data || []}
        onChange={props.onChange}
      />
    );
  };

  handleNewTableRow = () => {
    const props = this.props;

    if (this.bodyGroup) {
      this.bodyGroup.open();
    }

    props.data.unshift({
      contents: []
    });

    setTimeout(() => {
      instance.emit(`@addFrameMapping${this.state.tag}`, { isNew: true });
    }, 0.1);
  };
}
